/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";

// Material Kit 2 PRO React examples
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";



function Caracteristicas() {
  return (
    <MKBox component="section" pt={3} pb={8}>
      <Container>
        <Grid container justifyContent="center" sx={{ textAlign: "center" }}>
          <Grid item xs={12} md={3}>
            <DefaultCounterCard
              count={8}
              separator=","
              title="Países"
              description="na América Latina com presença da FMP Soluções"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultCounterCard
              count={20000}
              separator=","
              suffix="+"
              title="Horas"
              description="de experiência em desenvolvimento de soluções de alta tecnologia."
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultCounterCard
              count={24}
              suffix="/7"
              title="Suporte"
              description="Nossas equipes estão sempre à disposição."
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Caracteristicas;
